module.exports = __webpack_public_path__ + "media/atlas.275b5235.mp4";